import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { Department } from '@app/features/scoping/models/department.model'
import { DepartmentChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/department-with-changes.interface'

export function getDepartmentChanges(
  department: Department,
  previewDepartment: Department,
  component: ScopeComponent,
  previewComponent: ScopeComponent
): DepartmentChanges {
  if (!previewDepartment) previewDepartment = department

  return {
    rateCardTotalHours: {
      old: department?.getTotalRateCardHours(),
      new: previewDepartment?.getTotalRateCardHours(),
    },
    agencyPrice: {
      old: department?.getTotalSellingPrice({ markup: component.costPlusValue })?.amount,
      new: previewDepartment?.getTotalSellingPrice({ markup: previewComponent?.costPlusValue })?.amount,
    },
  }
}
